import { createContext, useContext, type ReactNode } from 'react';
import { getDeploymentConfig } from './configLoader';
import type { DeploymentConfig } from './types';

const ConfigContext = createContext<DeploymentConfig | undefined>(undefined);

export const ConfigProvider = ({ children }: { children: ReactNode }) => (
  <ConfigContext.Provider value={getDeploymentConfig()}>
    {children}
  </ConfigContext.Provider>
);

export const useDeploymentConfig = (): DeploymentConfig => {
  const config = useContext(ConfigContext);

  if (!config)
    throw new Error('useDeploymentConfig must be used inside ConfigProvider');

  return config;
};
